export default __webpack_public_path__ + "static/media/Repair Man.b5240688.jpg";